import preprationItemPrint from "./preprationItemPrint";
import { normalizeOrderForPrint } from "./printNormalizerForinPrepration";

export const handleBrowserPrintPrepration = async (orderDetails, _invoiceData, orderId) => {
  const normalizedOrder = normalizeOrderForPrint({
    ...(orderDetails || {}),
    order_number: orderDetails?.order_number || orderId,
  });

  if (!normalizedOrder.items.length) {
    alert("لا توجد أصناف صالحة للطباعة.");
    return false;
  }

  const printWindow = window.open("", "printWindow", "width=400,height=600");
  if (!printWindow) {
    alert("المتصفح منع نافذة الطباعة. اسمح بالنوافذ المنبثقة.");
    return false;
  }

  const html = await preprationItemPrint(normalizedOrder);

  printWindow.document.open();
  printWindow.document.write(html);
  printWindow.document.close();
  printWindow.focus();

  const tryClose = () => {
    try {
      if (printWindow && !printWindow.closed) printWindow.close();
    } catch (e) {}
  };

  printWindow.onafterprint = tryClose;
  try {
    printWindow.addEventListener &&
      printWindow.addEventListener("afterprint", tryClose);
  } catch (e) {}

  const fallbackTimer = setTimeout(() => tryClose(), 12000);

  const safePrint = async () => {
    try {
      if (printWindow.__waitForAssets) {
        await printWindow.__waitForAssets();
      } else {
        await new Promise((resolve) => setTimeout(resolve, 400));
      }
    } catch (e) {}

    try {
      printWindow.print();
    } catch (e) {
      console.error("فشل أمر الطباعة", e);
    }
  };

  await safePrint();

  const pollInterval = setInterval(() => {
    if (!printWindow || printWindow.closed) {
      clearInterval(pollInterval);
      clearTimeout(fallbackTimer);
    }
  }, 500);

  return true;
};
